import {
  _dexeroUiInteractionsBindings,
  IDexeroUiInteractionsBindings,
} from './DexeroUiInteractions/_dexeroUiInteractionsBindings';
import {
  _toggleScrollToTopButton,
  IToggleScrollToTopButton,
} from './DexeroUiInteractions/_toggleScrollToTopButton';
import {
  appendCurrentUrlBeforeRedirect,
  IAppendCurrentUrlBeforeRedirect,
} from './DexeroUiInteractions/appendCurrentUrlBeforeRedirect';
import {
  changeUrlParamOnClick,
  IChangeUrlParamOnClick,
} from './DexeroUiInteractions/changeUrlParamOnClick';
import { IInitLogoutTimer, initLogoutTimer } from './DexeroUiInteractions/initLogoutTimer';
import { IPrintArea, printArea } from './DexeroUiInteractions/printArea';
import { ISlideSteps, slideSteps } from './DexeroUiInteractions/slideSteps';
import { ISwitchLanguage, switchLanguage } from './DexeroUiInteractions/switchLanguage';
import { IViewReadonlyChild, viewReadonlyChild } from './DexeroUiInteractions/viewReadonlyChild';

export interface IDexeroUiInteractions {
  _dexeroUiInteractionsBindings: IDexeroUiInteractionsBindings;
  _toggleScrollToTopButton: IToggleScrollToTopButton;
  appendCurrentUrlBeforeRedirect: IAppendCurrentUrlBeforeRedirect;
  changeUrlParamOnClick: IChangeUrlParamOnClick;
  initLogoutTimer: IInitLogoutTimer;
  printArea: IPrintArea;
  slideSteps: ISlideSteps;
  switchLanguage: ISwitchLanguage;
  viewReadonlyChild: IViewReadonlyChild;
}

const DexeroUiInteractions: IDexeroUiInteractions = {
  // Bindings
  _dexeroUiInteractionsBindings,

  // Toggle scroll to top button
  _toggleScrollToTopButton,

  // Add current window url to the link before redirect to have a return url already in paramaters
  appendCurrentUrlBeforeRedirect,

  // Change a URL paramter on click before redirecting to the page
  changeUrlParamOnClick,

  // Show user he's about to be logged out if he's inactive for too long
  initLogoutTimer,

  // Copy document.body.innerHTML into $target
  printArea,

  // Slide animation to toggle back and forth between content
  slideSteps,

  // Switch lange in language button group
  switchLanguage,

  // When child card is readonly save parent before proceeding to child
  viewReadonlyChild,
};

export default DexeroUiInteractions;
